import { Banner, BannerStatus, ShowType } from "@/services/banner.service.ts";

const BASE_URL = "https://sharkroll-casino-prod.s3.eu-west-1.amazonaws.com";
export const mockBanners: Banner[] = Array.from({ length: 5 }, (_, index) => ({
  id: `banner_${index + 1}`,
  name: `Name ${index + 1}`,
  showType: ShowType.ALL_TIME,
  status: BannerStatus.DRAFT,
  orderNumber: index + 1,
  isDisplay: true,
  desktopUrl: `${BASE_URL}/assets/banners/${index + 1}.png`,
  mobileUrl: `${BASE_URL}/assets/banners/${index + 1}-mob.png`,
}));

export const defaultBanner: Banner = { id: "default_banner" };
